/**
 * This function returns a single string from a query string from query parameter
 *
 * @param queryString query string in query parameter
 * @returns a single string representing a search parameter attached to a page URL
 */
const getQueryString = (queryString: string | string[] | undefined): string => {
  if (queryString === undefined) return ''

  return typeof queryString === 'string' ? queryString : queryString[0]
}

export default getQueryString
